import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/Drawer": Drawer, "@mui/material/Button": Button, "@mui/material/List": List, "@mui/material/Divider": Divider, "@mui/material/ListItem": ListItem, "@mui/material/ListItemButton": ListItemButton, "@mui/material/ListItemIcon": ListItemIcon, "@mui/material/ListItemText": ListItemText, "@mui/icons-material/MoveToInbox": InboxIcon, "@mui/icons-material/Mail": MailIcon } } });
export default ClientProvider;
